import React, { useRef } from 'react';
import { ActivityStep, type ActivityStepHandle } from '../Activity';
import { ActivityTypeProps } from '../types';
import { PhonicsLogo, Parrot, ParrotType } from '@/components';
import { PhonicsActivityTypeMode } from '@/api/types';

interface ActivityTitleStepProps extends ActivityTypeProps {
  parrotType?: ParrotType;
  index: number;
  total: number;
}

const getPrefix = (mode: PhonicsActivityTypeMode): React.ReactNode => {
  if (mode === PhonicsActivityTypeMode.TEACH) {
    return (
      <>
        Phonics for Reading:
        <br />
      </>
    );
  } else if (mode === PhonicsActivityTypeMode.LEARN) {
    return (
      <>
        Phonics for Spelling:
        <br />
      </>
    );
  }

  return '';
};

export const ActivityTitleStep = ({
  children,
  parrotType = 'flying',
  activity,
  mode,
  wrapperClassName,
  isPreview,
  index,
  total,
}: React.PropsWithChildren<ActivityTitleStepProps>) => {
  const activityStepRef = useRef<ActivityStepHandle | null>(null);

  return (
    <ActivityStep
      ref={activityStepRef}
      stepIdentifier={`${activity.id}-${index}-title`}
      activity={activity}
      mode={mode}
      stepNumber={index + 1}
      totalSteps={total}
      wrapperClassName={wrapperClassName}
      bgColor="red"
      isPreview={isPreview}
      showTitle={false}
      showActivityPagination={false}
      onSlideSettle={() => {
        activityStepRef.current?.showHelpTooltip();
      }}
    >
      <div className="flex flex-col md:flex-row gap-24 justify-center items-center">
        <div className="flex justify-center w-full md:w-1/3">
          <Parrot className="w-full h-auto" type={parrotType} />
        </div>

        <div className="w-full md:w-1/3">
          <h2 className="flex flex-col text-2xl font-bold text-white text-left leading-relaxed">
            {getPrefix(activity.type.mode)}

            <span className="text-5xl">{activity.type.name}</span>

            <PhonicsLogo className="w-48 h-auto mt-6" />
          </h2>
        </div>
      </div>

      {children}
    </ActivityStep>
  );
};
